import React from "react";
import { Dialog, makeStyles } from "@material-ui/core";
import WebApi from "api/ApiConstants";

const FlightUpdateMarkup = (props) => {
    const classes = useStyles();

    const handleClose = () => {
        props.setIsUpdateMarkup(false);
    };

    const handleInputValueChange = (e) => {
        props.setMarkup(e.target.value);
    };

    const updateMarkup = () => {
        if(props.markup && props.ticketId) {
            props.setIsLoading(true);
            WebApi.doMarkupUpdate({ 
                markup: props.markup !== "" ? props.markup : 0, 
                tid: props.ticketId 
            }, function (
                response
            ) {
                if (response.success === true) {
                    props.setIsError(false);
                    props.setIsSuccess(true);
                    props.setInfoText(response.message);
                } else {
                    props.setIsError(true);
                    props.setIsSaving(false);
                    props.setInfoText(response.message);
                }
                props.setIsLoading(false);
            }, function(error) {
                props.setIsLoading(false);
                console.error("Error", error);
                props.setInfoText(`Failed to update markup!`);
                props.setIsError(true);
            });
        } else {
            props.setInfoText("Markup value cannot be empty!");
            props.setIsError(true);
        }
    };

    return(
        <Dialog
            open={props.isUpdateMarkup}
            onClose={handleClose}
            PaperProps={{
                className: classes.dialogPaper,
            }}
        >
            <div className="ticket-delivery-card flex-box align-items-center">
                <span className="dialog-close-button" onClick={handleClose}>x</span>
                <div className="form-element ticket-col">
                    <label>Markup</label>
                    <input value={props.markup} onChange={handleInputValueChange}/>
                </div>
                <div className="form-element ticket-col btn-element">
                    <button className="btn btn-submit" onClick={updateMarkup}>Update Markup</button>
                </div>
            </div>
        </Dialog>
    );
};

export default FlightUpdateMarkup;

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        "& .ticket-delivery-card": {
            position: "relative"
        },
        "& button, .dialog-close-button": {
            cursor: "pointer"
        },
        "& .dialog-close-button": {
            position: "absolute",
            top: 0,
            right: 0,
            height: 20,
            width: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }
}));
